import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChargesDistributionComponent } from './charges-distribution/charges-distribution.component';
import { ChargesComponent } from './charges/charges.component';

const chargesModuleRoutes: Routes = [
  { path: 'charges/:cnpj', component: ChargesComponent },
  { path: 'chargesdistribution/:cnpj', component: ChargesDistributionComponent },
];

@NgModule({
  imports: [RouterModule.forChild(chargesModuleRoutes)],
  exports: [RouterModule],
})
export class ChargesModuleRoutingModule {}
